import { useEffect, useState } from 'react';

export default function LeadPopup() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const already = sessionStorage.getItem('popup_dismissed');
    if (already) return;
    const timer = setTimeout(() => setShow(true), 45000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setShow(false);
    setDismissed(true);
    sessionStorage.setItem('popup_dismissed', '1');
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) return;
    setLoading(true);
    try {
      const body = new URLSearchParams();
      body.append('name', name);
      body.append('phone', phone);
      await fetch('https://readdy.ai/api/form/d781u8hrcamcd36darug', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setTimeout(dismiss, 2500);
    } catch {
      setSubmitted(true);
      setTimeout(dismiss, 2500);
    } finally {
      setLoading(false);
    }
  };

  if (!show || dismissed) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-end sm:items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)' }}
    >
      <div
        className="relative w-full max-w-md rounded-3xl overflow-hidden border border-[#d4af37]/40 animate-[slideUp_0.4s_ease-out]"
        style={{ background: 'rgba(13,17,23,0.98)', backdropFilter: 'blur(40px)', boxShadow: '0 0 80px rgba(212,175,55,0.15)' }}
      >
        {/* Top accent */}
        <div className="h-1 w-full bg-gradient-to-r from-[#d4af37] via-[#f4d03f] to-[#d4af37]" />

        <button
          onClick={dismiss}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/5 text-white/50 hover:text-white hover:bg-white/10 transition-all cursor-pointer"
        >
          <i className="ri-close-line text-base"></i>
        </button>

        <div className="p-7">
          {!submitted ? (
            <>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-[#d4af37]/15">
                  <i className="ri-gift-2-line text-2xl text-[#d4af37]"></i>
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="w-2 h-2 flex items-center justify-center">
                      <span className="block w-2 h-2 rounded-full bg-[#00d9ff] animate-pulse" />
                    </span>
                    <span className="text-[#00d9ff] text-xs font-bold uppercase tracking-widest">Özel Fırsat</span>
                  </div>
                  <h3 className="text-white font-black text-lg leading-tight">
                    Özel kampanyalardan ilk siz haberdar olun
                  </h3>
                </div>
              </div>

              <p className="text-white/50 text-sm mb-6 leading-relaxed">
                Telefon numaranızı bırakın, size özel fırsatları kaçırmayın.
              </p>

              <form
                data-readdy-form
                id="popup-firsat-form"
                onSubmit={handleSubmit}
                className="flex flex-col gap-3"
              >
                <div className="relative">
                  <i className="ri-user-line absolute left-4 top-1/2 -translate-y-1/2 text-white/30 text-sm"></i>
                  <input
                    type="text"
                    name="name"
                    placeholder="Ad Soyad"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    className="w-full h-12 pl-10 pr-4 rounded-xl bg-white/5 border border-white/10 focus:border-[#00d9ff]/60 text-white text-sm placeholder-white/30 outline-none transition-colors"
                  />
                </div>
                <div className="relative">
                  <i className="ri-phone-line absolute left-4 top-1/2 -translate-y-1/2 text-white/30 text-sm"></i>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Telefon Numarası"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                    className="w-full h-12 pl-10 pr-4 rounded-xl bg-white/5 border border-white/10 focus:border-[#00d9ff]/60 text-white text-sm placeholder-white/30 outline-none transition-colors"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full h-13 py-3.5 rounded-xl bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-black text-sm hover:scale-[1.02] hover:shadow-[0_0_25px_rgba(212,175,55,0.4)] transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-70"
                >
                  {loading ? 'Gönderiliyor...' : 'Fırsat Listesine Katıl'}
                </button>
              </form>

              <div className="flex items-center justify-center gap-2 mt-3">
                <i className="ri-lock-line text-white/20 text-xs"></i>
                <span className="text-white/20 text-xs">Spam göndermiyoruz</span>
              </div>
            </>
          ) : (
            <div className="text-center py-6">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-green-400/15 mx-auto mb-3">
                <i className="ri-check-line text-2xl text-green-400"></i>
              </div>
              <h3 className="text-white font-black text-lg mb-1">Listeye Eklendiniz!</h3>
              <p className="text-white/40 text-sm">Yakında sizi arayacağız.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
